import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { TripProvider } from "./context/TripContext";

// ✅ Load CSS globally (order matters)
import "./styles/theme.css";        // tokens / vars
import "./styles/components.css";   // shared components
import "./styles/main.css";         // pages / layout
import "./styles/app.css";          // native iOS-style app overrides

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <TripProvider>
            <App />
        </TripProvider>
    </React.StrictMode>
);
